export default __webpack_public_path__ + "assets/d6ab2aa761f7996ef9a0f0df743caef8.png";